import React from 'react';
import { Box, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import { ChatLogsT } from '../../types/chat';

interface ChatLogsFilterProps {
  chatLogs: ChatLogsT[];
  setMonthYear: (monthYear: string) => void;
  selectedMonthYear: string | null;
}

export const ChatLogsFilter: React.FC<ChatLogsFilterProps> = ({
  chatLogs,
  setMonthYear,
  selectedMonthYear,
}) => {
  const sortingMonths = [
    ...new Set(
      chatLogs.map(chatLog =>
        new Date(chatLog.updatedAt || Date.now()).toLocaleString('default', {
          month: 'short',
          year: 'numeric',
        })
      )
    ),
  ];
  return (
    <Box sx={{ width: 240 }}>
      <FormControl size="small" fullWidth>
        <InputLabel className="">Select Months</InputLabel>
        <Select
          value={selectedMonthYear ? selectedMonthYear : 'All'}
          label="Select Month"
          onChange={e => setMonthYear(e.target.value as string)}
          renderValue={selected => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{selected}</Box>
          )}
        >
          <MenuItem key="all" value="All">
            All
          </MenuItem>
          <MenuItem key="unread" value="Unread">
            Unread
          </MenuItem>
          {sortingMonths.map((month, index) => (
            <MenuItem key={index} value={month}>
              {month}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
